"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*eslint-disable */
var _default = {
  name: 'CHEVRON_DOWN_LINE',
  path: 'M16.893 9l-4.6 4.6-4.6-4.6L7 9.693l5.293 5.293 5.293-5.293z',
  viewBox: '0 0 24 24',
  invert: false
};
/*eslint-enable */

exports["default"] = _default;